import { EarningsDataEnum, EarningsEstimateType } from './types'

export enum EarningsWidgetCategory {
  Eps,
  EpsGaap,
  Revenue,
}

export const EARNINGS_WIDGET_LABELS: Record<EarningsWidgetCategory, string> = {
  [EarningsWidgetCategory.Eps]: 'EPS Performance and Forecast',
  [EarningsWidgetCategory.EpsGaap]: 'GAAP EPS Performance and Forecast',
  [EarningsWidgetCategory.Revenue]: 'Revenue Performance and Forecast',
}

export const ESTIMATE_TYPE_LABEL = {
  [EarningsEstimateType.eps]: 'EPS',
  [EarningsEstimateType.epsGaap]: 'GAAP EPS',
  [EarningsEstimateType.sales]: 'Sales',
}

export const BAR_WIDTH = 72
export const CHART_HEIGHT = 250
export const LABELS_WIDTH = 28
export const LABELS_MARGIN = 22
export const BAR_WIDTH_NARROW = 52
export const BAR_GAP = 16
export const EXTRA_WIDTH = 44
export const CHART_MARGINS = { top: 2, right: 0, bottom: 0, left: 0 }

export const DEFAULT_SETTINGS_FOR_EARNINGS_DATA = {
  [EarningsDataEnum.mainChange]: false,
  [EarningsDataEnum.mainChangePct]: false,
  [EarningsDataEnum.extraChangeYoYonQoQ]: false,
  [EarningsDataEnum.extraChangePctYoYonQoQ]: false,
}
